// Module
var code = "<template bindable=\"stateMessage\"> <span id=\"iccc-assessment-state-busy\"> <div class=\"ChangeHealthcareBusy\"> <img src=\"./app/ext/icons/ChangeHealthcareLogo.png\" alt=\"Change Healthcare Logo\"/> <div class=\"StateMessage\"> <h3>${stateMessage}</h3> </div> </div> </span> </template> ";
// Exports
module.exports = code;